const en = {
  advanced_setting: 'Advanced Setting',
  createProject: 'Create Project',
  unset: 'unset',
  projectSetName: 'project set name',
  text_package_config_edit: 'edit',
  text_package_config_edit_role: 'Edit role',
  text_update_package_config: ' update build config may trigger clean build package,do you confirm to update',
  text_build_package_num_config: 'build package config',
  text_build_package_config_help: 'build package config help',
  text_app_package_num: 'app build package num',
  text_online_package_num: 'online build package num',
  text_build_package_config_switch: 'build pcakage config switch',
  text_build_package_operation: 'operation',
  text_build_package_update: 'edit',
  text_build_package_input: 'please enter',
  text_build_package_enter_num: 'please enter number over 0',
  text_build_package_detail: 'build package detail',
  text_build_package_app_id: 'app id',
  text_build_package_app_name: 'app name',
  text_choose_status: 'please choose status',
  text_status_on: 'open',
  text_status_off: 'close',
  text_config_error_app_package_limit_must_over_online_limit: 'app package count limit must over online package count  limit',
  text_build_package_app_size: 'app build package size',
  label_select_code_template: 'Choose Template',
  label_select_language: 'Choose Language',
  label_pending: 'Todo',
  label_my_create: 'Created',
  label_my_collect: 'Favorites',
  label_issue: 'Defect',
  label_requirement: 'Requirement',
  label_task: 'Task',
  label_risk: 'Risk',
  label_projectSet: 'Program',
  label_project: 'Project',
  label_productline: 'Product',
  text_submit_time: 'Submit time',
  label_actualDate: 'Actual Start&End Date',
  label_select: 'select',
  label_yes: 'Yes',
  label_no: 'No',
  text_please_input: 'Please input',
  text_please_type_integer: 'Please type an integer',
  text_please_type_number: 'Please type a number',
  text_custom_attribute: 'Custom attribute',
  text_Owner_department: 'Owner Team',
  text_open_to_department: 'Public to',
  text_owner_product: 'Owner product/BU',
  label_search_keyword: 'Enter keywords to Search',
  label_description: 'Description',
  tip_desc_required: 'Enter the Description',
  label_expectDate: 'Expected Start&End Date',
  text_Health: 'Health',
  text_Good: 'Good',
  text_Medium: 'Medium',
  text_Bad: 'Bad',
  label_thumbnail: 'Thumbnail',
  text_Lifecycle: 'Lifecycle',
  text_Doing: 'Doing',
  text_Done: 'Done',
  text_Canceled: 'Canceled',
  text_Visibility: 'Visibility',
  text_Public_project: 'Public',
  label_visitable_by_all: 'Visible to everyone',
  text_Private_project: 'Private',
  label_visitable_only_by_project_member: 'Only visible to members',
  label_project_name: 'Project Name',
  tip_project_title_required: 'Enter the project name',
  tip_program_title_required: 'Enter the program name',
  label_portfolio_name: 'Portfolio Name',
  click_this_to_create_new_project: 'Click this, then you can create a new project',
  click_this_to_choose_project: 'Click this, then you can choose a project',
  git_repo_can_not_be_empty: 'Git repo url should not be empty',
  git_repo_format_error: 'Code repo url is invalid',
  git_repo_url_placeholder: 'Existing code repo url (like git@example.aliyun.com:ns/repo.git).',
  text_Please_input_name: 'Please input name',
  label_name: 'Name',
  text_Parent_project: 'Parent Project',
  label_productLine: 'ProductLine',
  text_Parent_production: 'Parent production',
  text_portfolio_parent: 'Portfolio parent',
  label_parent_project: 'Parent Project',
  label_portfolio_belongs_to: 'The portfolio belongs to',
  label_progress_percentage: 'Schedule',
  label_related_project: 'Related Project(Program)',
  text_portfolio_components: 'Portfolio components',
  label_belonged_project_set: 'Belonged Program',
  text_Classification: 'Classification',
  text_Namespace: 'Namespace',
  text_Develop_project: 'Develop project',
  label_project_type: 'Project Type',
  text_name: 'Name',
  text_Public: 'Public',
  text_Accessible_for_everyone: 'Visible to everyone',
  text_private: 'Private',
  text_Accessible_for_project_members: 'Only visible to members',
  text_Next: 'Next',
  label_prev_step: 'Prev Step',
  text_Compete: 'Complete',
  label_base_info: 'Basic Information',
  text_config_project_group: 'Portfolio components config',
  label_complete: 'completed',
  text_Administrator: 'Administrator',
  text_Accept2: 'Accept',
  text_Deny2: 'Deny',
  text_Cancel_admin: 'Cancel admin',
  text_Set_admin: 'Set admin',
  text_Remove: 'Remove',
  text_Pending: 'Pending',
  text_Accepted: 'Accepted',
  text_Invalid: 'Invalid',
  text_Refused: 'Refused',
  text_Selected_: 'Selected ',
  text__items: ' items',
  text_Accept_all: 'Accept all',
  text_Deny_all: 'Deny all',
  text_Active_members: 'Active Members',
  text_Member_Name: 'Name',
  text_Nick_Name: 'Nick Name',
  text_email: 'Email',
  text_Department: 'Department',
  text_Mobile: 'Mobile',
  text_Staff_ID: 'Staff ID',
  text_Invitation_list: 'Invitation List',
  label_status: 'Status',
  text_Waiting_for_approval: 'Waiting For Approval',
  text_Refused_list: 'Refused List',
  text_Copy_successfully: 'Copy successfully',
  text_Add: 'Add',
  text_convert_billing: 'Switch Billing Policy Hint',
  text_click_to_switch: 'Click to swtich',
  text_switch_billing_success: 'Please close the dialog, and continue adding memeber',
  text_switch_billing_faied: 'Switch Failed: ',
  text_Invitation_Link: 'Invitation Link',
  text_invitation_link_tip: 'Share the link to invite other people to this company',
  text_This_invitation_remain_valid_till_: 'This invitation remains valid till ',
  text_Copy: 'Copy',
  text_RAM: 'RAM',
  text_ram_tip1: 'You can add following sub account, or',
  text_ram_tip2: ' go to RAM to add sub account',
  text_ram_tip3: '. If you need help ',
  text_ram_tip4: 'click here',
  text_Display_name: 'Display name',
  text_Login_user_name: 'Login user name',
  label_ok: 'OK',
  text_Invitation_Email: 'Invitation Email',
  text_Email_textarea_tip: 'Please input email address, one email per line, less than 20 lines.',
  text_Within_10_characters: 'Within 10 characters',
  text_Apply_to_join_company: 'Apply to join company',
  text_Name: 'Name',
  text_Please_type_your_name_correctly: 'Please type your name correctly',
  text_Please_input_your_email: 'Please input your email',
  text_Invalid_emails: 'Invalid emails',
  text_Join_Company: 'Join Company',
  text_Your_application_is_waiting_for_approval_please_wait: 'Your application is waiting for approval please wait',
  text_Invalid_invitation_please_contact_the_administrator: 'Invalid invitation, please contact the administrator',
  text_Your_application_has_been_approved_you_can: 'Your application has been approved, you can',
  text__enter_the_company: ' enter the company',
  text_Your_application_has_been_denied_please_contact_the_administrator: 'Your application has been denied, please contact the administrator',
  text_Please_input_company_name: 'Please input company name',
  text_Invite_Member: 'Invite Member',
  text_Please_select_your_company: 'Please select the company you want to access',
  text_Switch: 'Switch',
  text_No_company: 'No company, ',
  text_to_create_a_new_one: ' to create a new one',
  tip_program_title_exist: 'Program name already exists, please retry.',
  tip_Plan_end_time_before_start_time: 'Planed complete time must be after planed start time',
  label_solution: 'Solution',
  label_new_projectset: 'New Program',
  text_config_members: 'Config Members',
  text_config_joined_projects: 'Config Programs',
  label_next_step: 'Next Step',
  text_program_manager: 'Program Manager',
  tip_enter_program_manager: 'Please Enter Program Manager',
  text_program_member: 'Program Member',
  tip_enter_program_member: 'Please Enter Program Member',
  label_cancel: 'Cancel',
  label_config_scrum: 'Set Scrum Team',
  tip_scrum_master_require: 'scrum master is required',
  tip_product_owner_require: 'product owner is required',
  tip_scrum_member_require: 'scrum member is required',
  text_required_please_input: 'Required field, please input',
  text_import: 'Import',
  text_apply: 'Apply',
  label_product: 'Product',
  text_Todo: 'Todo',
  label_view_all: 'All',
  label_empty_data: 'No data',
  text_my_favorite: 'My Favorite',
  tip_empty_data: 'No relevant result',
  label_view_more: 'View More',
  text_todo_clear_tip: 'Congratulations, you have finished all the todo items.',
  text_portfolio: 'Portfolio',
  label_Plan_start_and_end_time: 'Planed Time',
  label_Plan_start_time: 'Planed Start',
  label_Plan_end_time: 'Planed Complete',
  tip_plan_start_after_end: 'Planned start time must before Planned completed time',
  label_creator_and_created_at: 'Creator and CreatedAt',
  label_Actual_start_and_end_time: 'Actual Time',
  label_Actual_start_time: 'Actual Start',
  label_Actual_end_time: 'Actual Complete',
  text_person_in_charge: 'Person in charge',
  text_Risk_progress: 'Risk progress',
  text_update_time: 'Update Time',
  text_latest_complated_milestone: 'Milestone completed recently ',
  text_edit: 'Edit',
  label_collection: 'Collect',
  tip_create_at: 'Created At',
  label_visible_range: 'Visible',
  label_detail: 'detail',
  label_Risk_summary: 'Risk Summary',
  text_Display_Sub_project_Risk: 'Display Sub-project Risk',
  label_risk_level: 'Risk Level',
  text_status: 'Status',
  label_owner_project: 'Belonged Project',
  text_create_time: 'Create Time',
  label_private: 'private',
  label_new_project: 'New Project',
  text_tip_title: 'Tip',
  label_create_project_step: 'Create Project',
  label_create_git_step: 'Create Git',
  label_create_app_step: 'Create Application',
  label_start_project: 'enter project',
  label_skip_project: 'skip, enter project',
  label_config_git: 'Config Git Group',
  label_git: 'Git Group/Project',
  label_git_repo: 'Git repo url',
  text_select_git_group: 'Please Select Git Group',
  label_application_name: 'Application Name',
  text_input_application_name: 'Please Input Application Name',
  label_Initiate_code_template: 'Code Template',
  label_develop_mode: 'Develop Mode',
  text_select_develop_mode: 'Please Select Mode For Develop',
  label_develop_mode_free: 'Free',
  label_read_more: 'More',
  label_develop_mode_branch: 'Branch',
  label_develop_mode_gitFlow: 'Git Flow',
  label_docker_build_or_not: 'Docker build',
  label_app_release_language: 'Develop language',
  label_application_type: 'Application type',
  label_deploy_option: 'Deploy options',
  label_build_config_step: 'Build Config',
  label_deploy_config_step: 'App Config',
  label_code: 'Code',
  label_test: 'Test',
  label_publish: 'Publish',
  label_service_common: 'Common',
  label_service_general: 'Common',
  label_service_product: 'Product',
  label_service_develop: 'Develop',
  label_service_testing: 'Test',
  label_service_publish: 'Publish',
  label_service_other: 'Other',
  label_service_doc: 'Doc',
  label_service_tile_workitem: 'Workitem',
  label_service_tile_report: 'Report',
  label_service_tile_chart: 'Chart',
  label_service_tile_kanban: 'Kanban',
  label_service_tile_risk: 'Risk',
  label_service_tile_report2: 'Weekly Report',
  label_service_tile_document: 'Doc',
  label_service_tile_resource: 'Resource',
  label_service_tile_milestone: 'Milestone',
  label_service_tile_meeting: 'Meeting',
  label_service_tile_lark: 'Lark',
  label_service_tile_req: 'Req',
  label_service_tile_demo: 'Demo',
  label_service_tile_projectChange: 'Project Change',
  label_service_tile_version: 'Version',
  label_service_tile_version_app_config: 'App Config',
  label_service_tile_task: 'Task',
  label_service_tile_sprint: 'Sprint',
  label_service_tile_code: 'Code',
  label_service_tile_pipeline: 'Pipeline',
  label_service_tile_project_pipeline: 'Project Pipeline',
  label_service_tile_issue: 'Defect',
  label_service_tile_lab: 'Lab',
  label_service_tile_TC: 'TC',
  label_service_tile_regression: 'Regression',
  label_service_tile_test: 'Test',
  label_service_tile_crDev: 'Cr',
  label_service_tile_app: 'App',
  label_service_tile_alipay_doccenter: 'Javis Doc',
  label_service_tile_product_version_app_config: 'Product Version App Config',
  label_service_tile_product_version: 'Version',
  label_service_tile_lib: 'Lib',
  label_service_tile_product_version_inst: 'Inst',
  label_service_tile_file: 'File',
  label_service_tile_planItem: 'Plan Item',
  label_service_desc_workitem: 'Work items,including tasks,requirements,defects,which help project management and implementation',
  label_service_desc_report: 'Multi-dimensional project data analysis',
  label_service_desc_chart: 'Multi-dimensional project data analysis',
  label_service_desc_kanban: 'Improve the efficiency of collaboration by kanban view,rapid advancement of focused matters,and agile development practices',
  label_service_desc_risk: 'Manage project risks,timely notification,and report at different levels',
  label_service_desc_report2: 'Weekly Report',
  label_service_desc_document: 'Keep documents and precipite knowledge',
  label_service_desc_resource: 'Project human resource management',
  label_service_desc_milestone: 'Milestones and specific work items in the overall planning project',
  label_service_desc_meeting: 'Meeting management',
  label_service_desc_lark: 'Lark knowledge base',
  label_service_desc_req: 'Record,view requirements,customize workflows,add custom fields for easy tracking management',
  label_service_desc_demo: 'Open Demo+',
  label_service_desc_projectChange: 'Unified management project requirements,milestone plans,and personnel changes',
  label_service_desc_version: '版本',
  label_service_desc_version_app_config: 'Configure the version rule of the app: fixed version or latest version',
  label_service_desc_task: 'Record daily to-do items and follow up on progress',
  label_service_desc_sprint: 'Use Sprint to manage requirements to be delivered. You can lock the sprint to ensure requirements would not change',
  label_service_desc_code: 'Code',
  label_service_desc_pipeline: 'Self-configurable release pipeline',
  label_service_desc_project_pipeline: 'Project Pipeline',
  label_service_desc_issue: 'Manage defects,which can be linked to code changes and easily to be tracked by develop and test classmate',
  label_service_desc_lab: 'Lab',
  label_service_desc_TC: 'Test cases provide manual use case management for testing students to record and view test steps and test results',
  label_service_desc_regression: 'The regression function provides a daily timed regression of the application-stable test function script (lab) to verify the quality of the test product',
  label_service_desc_test: 'Test services are used to provide users with a standardized test service capability',
  label_service_desc_crDev: 'The change request including code,package,container and is used to ensure the quality by integrating with security audit tools and  CI  process',
  label_service_desc_app: 'Application lifecycle, metadata management, basic information related to the application, and change release can be found here',
  label_service_desc_alipay_doccenter: 'Javis Doc',
  label_service_desc_product_version_app_config: 'Configure the version rule of the app: fixed version or latest version',
  label_service_desc_product_version: 'Define product version, manage defect by version',
  label_service_desc_lib: 'Project two-party library service',
  label_service_desc_product_version_inst: 'Product version of the product. Every time you run the product version pipeline, there will be a unique product generation',
  label_service_desc_file: 'File service of aone2',
  label_service_desc_planItem: 'Making Product Planning, organization and management requirement',

  label_plugin_desc_model: 'Define product modules or business modules in a tree structure,used to classify requirements defects',
  label_plugin_desc_tag: 'Tag requirements, defects, sub-projects, etc., classification management',
  label_plugin_desc_version: 'Define product version, manage defect by version',
  label_plugin_desc_across_enterprise: 'Share data within the project with another enterprise',
  label_plugin_set_across_enterprise_tip: 'Share project data among cooperative Enterprises',
  label_plugin_cancel_across_enterprise_tip: 'Cancel share project data among cooperative Enterprises',

  text_feedback: 'Feedback',
  label_quick_start: 'Quick Start',
  label_help_doc: 'Document',
  label_edit: 'Edit',
  label_update_milestone: 'Edit Milestone',
  label_new_milestone: 'New Milestone',
  label_Actual_completed_time: 'Actual completed date',
  tip_actual_completed_time: 'Please input actual end date',
  tip_status_selected: 'Please select the state',
  label_module: 'Module',
  label_Plan_completed_time: 'Planned completed date',
  text_expected_end_date_hint: 'Please input planned date',
  tip_unfinished: 'Unfinished',
  tip_finished: 'Finished',
  text_Archived: 'Archived',
  text_display_archived_milestone: 'Display archived milestones',
  text_operation: 'Operation',
  text_tag: 'Tag',
  label_project_ascription: 'Ascription',
  label_project_plan: 'Plan',
  text_program_tip1: "Program contains sub-projects' data",
  text_program_tip2: 'But cannot manage project data',
  tip_archive_make_sure: 'Confirm to close project? Re-open is not allowed after the completion of project, please be careful',
  tip_archived_cancel_success: 'Archive canceled',
  tip_archived_success: 'Successful completion\n',
  label_archive_cancel: 'Cancel Archive',
  label_archive: 'Complete',
  tip_project_archive: 'Once the project is complete, the project can be marked as a closed item. ' +
  'Projects that have been closed are not displayed in the project list or project search results by default; ' +
  'workitems of the completed project will still be counted in the chart statistics; all sprints are automatically closed after the completion of the project, ' +
  'no new sprint can be added; workitems cannot be added after the completion of the project; the template cannot be modified after the completion of the project. ' +
  'Re-open is not allowed after the completion of project, please be careful!',
  tip_collection_cancel_success: 'Unfavorite success',
  tip_collection_success: 'Favorite success',
  label_collection_cancel: 'Cancel Collection',
  text_Update_success: 'Update success',
  text_Update: 'Update',
  tip_save_success: 'Save success',
  label_confirm: 'Confirm',
  text_Add_member_role: '+ Add member role',
  text_select_role: 'Please select role',
  tip_waiting_export: 'Exporting, result will be sent by wangwang and email;',
  tip_waiting_export_vpc: 'Exporting, result will be sent by email;',
  text_Export_members: 'Export Members',
  label_not_allow_to_delete_member: 'There is some members under this role that cannot be deleted!',
  tip_delete_make_sure: 'confirm to delete',
  label_delete: 'Delete',
  label_add_to_dingding_calendar: 'Add to calendar',
  label_covered_existing_member: 'Only new members will be added after exporting from other projects,are you sure to import?',
  text_run_success: 'Run Successfully',
  text_Import_members: 'Import Members',
  tip_project_selected: 'Please select the project',
  text_Success_to_remove_member: 'Success to remove member',
  label_select_role: 'Please select a role.',
  label_save: 'Save',
  text_Support_markdown: 'Support markdown',
  label_preview: 'Preview',
  label_remove: 'Remove',
  tip_enabled: 'Enable',
  label_drag_sort: 'Drag and drop to change order.',
  tip_opened: 'Enabled',
  label_all: 'All',
  text_remove_service_tip: 'The data will not be deleted after remove service',
  label_add: 'Add',
  text_create_a_new_version: 'create a new version',
  text_Display_archived_version: 'Display archived version',
  text_Unpublished: 'Unpublished',
  text_Published: 'Published',
  label_locale: 'en_US',
  text_Related_work_item: 'Related work item',
  label_Actual_publish_time: 'Actual Publish Time',
  label_Plan_publish_time: 'Planed Publish Time',
  text_Parent_version: 'Parent Version',
  label_New_module: 'Create Module',
  label_New_tag: 'Create Tag',
  label_share_tag: 'Share Tag',
  label_edit_tag: 'Edit Tag',
  text_tag_share_info: 'Tag share to',
  text_tag_share_sub_or_related: 'All descendant or related projects',
  text_tag_other_project: 'Other projects:',
  text_delete_module_success: 'Deleted successfully',
  tip_inherit_all: 'Are you sure to inherit all modules from parent?',
  text_Inherit_all: 'Inherit all modules from parent',
  label_Inherit_module: 'Inherit Module',
  tip_module_belong_to: 'The module belongs to ',
  tip_click_to_manager_module: 'click here to manager.',
  label_created_at: 'Created At',
  text_module_inherit_from: 'The module is inherited from ',
  text_module_remove_tip: ',it will be removed from the current project instead of being deleted,to delete please go to ',
  text_parent_module: 'Parent Module',
  remove_success: 'remove success',
  enable_success: 'enable success',
  label_cooperation_project: 'Cooperation Project',
  text_initiate_cooperation: 'Initiate Cooperation',
  text_participate_cooperation: 'Participate in Cooperation',
  label_project_title: 'Project Title',
  label_project_des: 'Project Description',
  label_share_content: 'Shared Content',
  text_choose_shared_info: 'Select the information you want to share with the partners:',
  text_project_base_info: 'Project base information',
  text_project_member_info: 'Project members',
  text_project_work_item: 'Work item and related configuration',
  label_own_info: 'Own Information',
  text_project_owners: 'Project Owners',
  text_project_members: 'Project Members',
  label_participant_info: 'Partner Information',
  text_partner_company: 'Partner Enterprise',
  label_invitation_code: 'Invitation code',
  delete_code_syatem_user: 'confirm to delete code system user',
  text_code_system_help: 'code system user help',
  code_system_user: 'code system user',
  enter_code_system_user: 'please enter username to search',
  label_warning: 'Warning',
  text_delete_project_info: 'To delete project with workitems,milestones,risks,versions,modules,sprints,applications and pipelines which could not be recovered.',
  text_delete_project_set_info: 'To delete project set with workitems,milestones,risks,versions,modules,sprints,applications and pipelines which could not be recovered. The relation of project set will be removed too.',
  text_delete_project_portfolio_info: 'To delete project portfolio and relation of it.',
  label_delete_project_number_str_vpc: 'There are $1 workitems,$2 milestones,$3 versions,$4 modules,$5 sprints,$6 applications and $7 pipelines and $8 documents.(The number of Testcase has not been counted yet.)',
  label_delete_project_number_str: 'There are $1 workitems,$2 milestones,$3 versions,$4 modules,$5 sprints,$6 applications, $7 pipelines, $8 documents and $9 testcases.',
  text_click_to_confirm_delete_project: '(Click to confirm to delete project)',
  text_click_to_confirm_delete_project_with_many_workitem: '(Submit to delete this project,which will be executed after 2 days because there are many workitems belongs to it.)',
  text_input_project_name_to_confirm: 'Please input project name to confirm to delete.',
  text_error_when_check_project_name: 'Check project name failed',
  text_submit_delete_project_tooltip: '$1 has submitted to delete this project at $2 and System will execute this task at $3.',
  label_empty_for_i18n: ' ',
  more_options: 'more_options',
  title_edit_view: 'Edit View',
  lable_crp_migrate: 'Migrate From CRP to RDC',
  refresh_login: 'Login status expired,please refresh the page.',
  test_create_issue_init_assignedTo: 'When you create a defect，“assignedTo” automatically set as module leader',
  test_go_into_all_defeat_types: 'will go into all types of defects',
  test_workflow_role_required_cf: 'Transfer permissions and required customField',
  test_confirm_to_create_code_account: 'confirm to create code sys account',
  test_confirm_to_delete_code_account: 'confirm to delete code sys account',
  test_create_code_account_success: 'create sys code sys account success',
  test_delete_code_account_success: 'delete code sys account success',
  test_create_code_account_fail: 'create code sys account fail,code sys account exist',
  test_delete_code_account_fail: 'delete code sys account fail',
  test_no_code_account: 'code sys account not exist',
  test_enter_right_code_account: 'please enter right code sys account',
  text_project_has_sub_project: 'There are $1 sub projects,you should move them away before delete this project.',
  text_project_is_collab: 'This project is collaborative,you should cancel this relation before delete this project.',
  text_across_enterprise: 'Cross-company Collaboration',
  text_project_submit_to_delete_success: 'Submit to delete project successfully',
  text_return: 'return',
  text_disabled: 'Disabled',
  text_delete_confirm: 'Sure to deleted',
  label_set_status_config_title: 'Transfer permissions and required customField setting',
  text_target_status: 'Target status',
  text_role_to_set_target_status: 'Roles authorized to change to the target status',
  text_target_status_set_cfs: 'When comes to the target status, custom fields have to be filled as follows',
  text_please_select_target_status: 'Select target status',
  text_run_failed: 'Run failed',
  text_select_required_cf: 'Select required custom field',
  text_has_right_rols: 'authorized roles',
  text_required_cf_before_status_flow: 'required custom fieldss before status change',

  text_custom_rule: 'Custom rule',
  text_add_rule: 'Add rule',
  text_input_rule_name: 'Input rule name',
  text_rule_name: 'Rule name',
  text_trigger_event: 'Trigger event',
  text_actuator: 'Actions',
  text_return_rule_list: 'return to rule list',
  text_add_rule_trigger: 'Add trigger event',
  text_add_actuator_group: 'Add actuator group',
  text_add_actuator: 'Add actuator',
  text_status_auto_flow: 'Status auto flow',
  text_window_to_fill_cfs: 'Alert window to fill custom field',
  text_select_status: 'select status',
  text_step_status_auto_flow: 'Status auto flow',
  text_step_window_to_fill_attrs: 'Alert window to fill attributes',
  text_when_status_is: 'when status is ',
  text_status_flow_to: ', then status comes to ',
  text_add_status_auto_flow: 'Add status auto flow',
  text_start_review: 'Workitem starts review',
  text_review_started_to_trigger_event: 'When workitem starts review, this event will be triggered.',
  text_finish_review: 'Workitem review passed',
  text_finish_review_to_trigger_event: 'When invited reviewers are all agreed with this review, this event will be triggered.',
  text_run_condition: 'Run condition',
  text_always_run: 'Always run',
  text_rule_name_not_null: 'Rule name can not be null',
  text_rule_actuators_not_null: 'Rule actuators can not be null',
  text_project_cancel_to_delete_success: 'Cancel deleting project',
  text_project_delete_success: 'Delete project successfully',

  text_rdc_ram_authorization_add: 'Confirm rdc authorization config?',
  text_rdc_ram_authorization_update: 'Confirm rdc re-authorization ?',
  text_rdc_ram_authorization_delete: 'Confirm delete rdc authorization?',
  text_rdc_ram_authorization_ram: 'Confirm ram authorization?',
  button_rdc_ram_authorization_rdc: 'config',
  button_rdc_ram_authorization_ram: 'authorization',
  button_rdc_ram_authorization_rdc_update: 'rdc re-authorization',
  button_rdc_ram_authorization_rdc_delete: 'cancel',
  text_rdc_ram_authorization_rdc_no_user_id: 'no authorization',
  text_rdc_ram_authorization_rdc_no_user_name: 'no authorization',
  label_rdc_ram_authorization_rdc_user_id: 'authorization user ID',
  label_rdc_ram_authorization_rdc_user_name: 'authorization user nickname',
  text_rdc_ram_authorization_msg_fail_delete: 'delete rdc authorization fail',
  text_rdc_ram_authorization_msg_fail_add: 'add authorization fail',
  text_rdc_ram_authorization_msg_fail_update: 'rdc re-authorization fail',
  text_assigned_to: 'Owner',
  label_empty_key: 'Empty',
  text_default_value: 'Default value',
  text_attr_name: 'Attribute Name',
  text_add_attr: 'Add attribute',
  text_rule_list_with_description: '<strong>Custom rule list</strong>(rules triggered will run with order from list)',
  text_trigger_event_can_not_be_null: 'Trigger event can not be null',
  text_delete_actuators: 'Delete Actuator',
  text_delete_rule_confirm: 'Sure to delete this rule?',
  label_code_repo_type: 'Repo Type',
  text_select_code_repo_type: 'please select your code repo name',
  text_Search_Region_Member: 'Input keyword, return search',
  text_disk_type_cloud: 'general cloud disk',
  text_disk_type_cloud_efficiency: 'efficient cloud disk',
  text_disk_type_cloud_ssd: 'SSD cloud disk',
  text_disk_type_ephemeral_ssd: 'local cloud disk',
  text_resource_specification: 'resource specification',
  text_security_groupName: 'security group',
  text_security_disk_type: 'disk type',
  text_security_disk_size: 'disk size',
  text_machine_name: 'machine name',
  text_machine_password: 'please enter machine password',
  text_lab_password: 'machine password',
  text_machine_buy: 'buy machine',
  text_tempalte_id: 'template id',
  text_tempalte_region: 'region',
  text_tempalte_name: 'template name',
  text_tempalte_language: 'template code language',
  text_tempalte_ip: 'ip',
  text_tempalte_status: 'status',
  text_tempalte_machine_password: 'machine password',
  text_tempalte_buy_num: 'number',
  text_buy_machine_id: 'MACHINE ID',
  text_go_aliyun_ecs: 'Go to aliyun ecs console',
  text_resource_specification_introduce: 'please enter the legal resources specifications, click here for detailed specifications ',
  label_disable: 'Disable',
  text_enable_confirm: 'Sure to enable?',
  text_disable_confirm: 'Sure to disable?',
  text_parent_workitem_done_or_cancel: 'Parent workitems done/cancel',
  text_child_workitem_done_or_cancel: 'All child workitems done/cancel',
  text_parent_workitem_done_or_cancel_description: 'This rule is provided by system, and it will be worked when enabled:' +
  '<br/>as parent workitem is done (<strong>meaning done normally</strong>)，' +
  'all unclosed child workitems will be set done status; as parent workitem is cancelled(<strong>meaning done abnormally</strong>),all unclosed child workitems will be cancelled.',
  text_child_workitem_done_or_cancel_description: 'This rule is provided by system, and it will be worked when enabled:<br/>as all child workitems are cancelled(<strong>meaning done abnormally</strong>),' +
  'parent workitem will be auto cancelled; as all child workitem are closed(<strong>meaning be set done</strong>）), including one done workitem at least, parent workitem will be set done.',
  text_disabled_rule: 'Disabled rules',
  text_rule_instruction: 'Rule instruction',
  text_save_failed: 'Save failed',
  text_role_set_to_status: '<span class="status-config-attr">Only <strong>$1</strong> can set status as <strong>$2</strong></span>',
  text_role_set_to_status_null: '<span class="status-config-attr">（No permission limit）</span>',
  text_cf_required_set_to_status: '<span class="status-config-attr">customField <strong>$1</strong> required</span>',
  text_cf_required_set_to_status_null: '<span class="status-config-attr">（no required customField）</span>',

  label_new_buildImage: 'Add Image',
  label_edit_buildImage: 'Edit Image',
  text_modify: 'modify',
  text_modify_time: 'modify time',
  text_creator: 'creator',
  text_modifier: 'modifier',
  text_image_name: 'image name',
  text_other_required_info: 'Other necessary info',
  label_start_time: 'Start Date',
  label_end_time: 'End Date',
  text_update_project_date_to_weekend: 'Make sure the start or end time is set on weekends?',
  label_update_project_date_hint: 'Update start or end time of the project(program)',
  text_milestone_date_weekend_hint: 'Attention: Milestone completed time is set on weekends',
  text_add_workitem_relation_change: 'Add new workitem relation with change',
  text_add_workitem_relation_change_description: 'When a change was related to workitem, this event will be triggered.',
  text_relation_change_publish: 'Related changes published',
  text_relation_change_publish_description: 'When all changes ware published successfully, this event will be triggered.',
  text_tab_machine_manage: 'Resource manage',
  text_tab_ecs_image_template: 'ECS image template',
  text_tab_buy_ecs_history: 'Machine purchase history',
  text_tab_private_proxy_machine: 'Proxy Machine',
  text_re_ecs_password: 're-paaword',
  text_not_same_ecs_password: 'Enter the password twice inconsistent',
  text_same_ecs_password: 'Enter the password twice to keep the same',
  text_button_buy_ecs: 'Buy ecs',
  text_button_buy_ecs_and_deploy: 'Buy Ecs and deploy',
  text_select_ecs_template: 'Now select template name is ',
  text_buy_ecs_number_is: 'Buy ecs number is',
  text_sure_to_buy_ecs: ',Are you sure to buy ',
  text_ecs_password_rule: '8 - 30 characters, must contain three items (uppercase, lowercase, numbers, () `~! @ # $% ^ & * - + = | {} []:; \'<>,. / In the special symbol）。',
  text_buy_ecs_ing: 'Buy ecs ing...',
  text_buy_ecs_help: 'Purchasing a machine on this page will automatically associate the machine with the current business. To buy a new machine, only charge ECS fees, you need to ensure that the account balance is sufficient',
  text_button_close: 'Close',
  text_button_show_ecs_history_detail: 'Show machine status',
  text_buy_ecs_time: 'Buy time',
  text_ecs_rehion: 'region',
  text_buy_ecs_operator: 'operator',
  text_buy_ecs_account: 'Buy account',
  text_buy_ecs_num: 'Ecs number',
  text_buy_ecs_type: 'Operate type',
  text_operate: 'Machine Status',
  text_now_ram_other: 'now is other',
  text_ram_nickname: 'Nick name',
  text_ram_help: 'Appropriate binding authorization, Rdc the members of  business, you can specify the cloud account through Alibaba Cloud identity, complete the purchase of ECS machines and other operations. See details',
  text_ram_help_doc: 'help document',
  text_ram_now_status: 'now status',
  text_ram_now_bind_and_authorization: 'Authorized and bound',
  text_ram_region_user: 'Rdc can use Aliyun main account',
  text_ram_region_username: 'identity to complete the operation.',
  text_ram_no_bind: 'not bind',
  text_ram_bind_and_authorzation: 'Authorize and bind',
  text_ram_authorization_step_1: 'The first step, authorized rdc right to use my identity to complete the operation。',
  text_ram_step_finish: ' Completed',
  text_ram_bind_step_2: 'The second step, configure the Rdc to use my identity to complete the operation.',
  text_ram_bind_step_2_pre: 'The second step, configure the Rdc to use my',
  text_ram_bind_step_2_suffix: ' identity to complete the operation.',
  text_ram_unbind: 'Unblock the current binding',
  text_ram_unbind_text_pre: 'Rdc  no longer use the current binding Aliyun main account',
  text_ram_unbind_text_suffix: 'to operate your resource',
  text_ram_now_bind_account: 'Now bind account is',
  text_ram_confirm_bind: 'Are you sure to rebind',
  text_ram_please_bind_first: 'Please authorize and  bind first',
  text_template_help: 'To ensure you create the correct template, please refer to the document for ECS instance related parameters, see the help document',
  text_build_image_requirement: 'the image need to be public and size is less than 1 GB',
  text_ecs_instance_detail_help: '1. to ensure that you can create a ECS template correctly, you may need to know the related parameters of the ECS instance, please refer to this document',
  text_create_template_help: '2. if you need further guidance, please refer to this document',
  text_custom_image_help: 'if you need a custom image, please refer to',
  text_only_vpc_instance_help: 'the yunxiao can only create a ECS instance based VPC, and if you want to create a VPC, please refer to',
  text_create_vswitch_help: 'to create VSwitch, please refer to',
  text_create_security_group_help: 'to create security group, please refer to',
  text_input_correct_resource_specification_help: 'please enter the legal resource specification. If you need to know the details of the resource specifications, please refer to',
  text_add_template_help_doc: 'help document',
  text_guide_for_inherit_from_parent: 'No configuration from parent project, please open the switch of using self project configuration and add rule.',
  text_use_self_project_config: 'Use current project configuration(inherited from parent project configuration as closed)',
  text_rule_custom_buttons: '<strong>Custom button</strong>(button will be displayed on workitem detail page, and you can configuration actions on button and run the button to trigger the actions)',
  text_rule_button_name: 'Button name',
  text_actuator_content: 'Action content',
  text_button_anthorized_role: 'Operation rights',
  text_button_visible_scope: 'Visible scope',
  text_button_name_not_null: 'Button name can not be null',
  tip_inherit_parent_permission_denied: 'Permission denied. Current operation can be done only by project admins, and you can contact project admins to get rights',
  tip_not_allowed_on_current_page: 'Not allowed on current page',
  text_all_statuses: '(all statuses)',
  text_all_roles: '(all project roles)',
  text_docker_repo_operate_failed: 'docker image operate failed ,please retry',
  label_delete_milestone: 'Delete Milestone',
  text_delete_success: 'Delete successfully',
  label_milestone_overall_title: ' Overall Plan',
  label_export: 'Export',
  label_set_to_completed: 'Set to completed',
  text_client_button: 'If deleted, the tag will disappear on all workitems, and delete it?',
  text_delete_share_tag_message: 'This is a shared tag,after deletion, it will not be displayed in this project',
  label_go_to_today: 'Today',
  hint_loading: 'Loading,please wait',
  text_add_url_link: 'Add url link',
  tip_input_url: 'Input url',
  text_url_link: 'Url link',
  text_url_link_example: 'Link contains project id and workitem id, eg. http://example.com?akProjectId=xxx&issueId=xxx',
  label_project_obj_name: 'Project(Program) Name',
  label_project_creator: 'Project Creator',
  label_admin_pm: 'Owner(PM)',
  label_milestone_cnt: 'Milestone Count',
  label_duration: 'Duration',
  text_day_singular: ' day',
  text_day_plural: ' days',
  hint_delay: 'Extended',
  hint_double_click_edit: 'Double-click to edit the content',
  hint_milestone_name_length: 'Milestone name length must be less than 50',
  hint_milestone_des_length: 'Milestone description length must be less than 1000',
  hint_milestone_name_null: 'Milestone name must not be null',
  text_milestone_date_weekend: 'Make sure the milestone is set on weekends?',
  text_set_workitem_readonly: 'Set Workitem readonly',
  tip_workitem_readonly: 'workitems on this type will be set readonly',
  tip_division_deleted: 'The current division has been deleted, please update',
  tip_milestone_before_project: 'Milestone planned completed date($1) is earlier than project start date,the project start date($2) will be adjusted to the planned completed time of milestone,confirm the update?',
  tip_milestone_after_project: 'Milestone planned completed date($1) is later than project end date,the project end date($2) will be adjusted to the planned completed time of milestone,confirm the update?',
  label_set_cancel: 'Set Canceled',
  tip_milestone_cnt_hint: 'The project(program) has ',
  tip_goto_milestone: ' milestone(s),click to view',
  tip_milestone_null: 'The project(program) has milestones',
  label_milestone_set_start_date: 'Milestone planned completed date is not set, please set on project setting page',
  label_milestone_illustration: 'Illustration',
  label_milestone_illustration_doing: 'Uncompleted and Undelayed Milestones',
  label_milestone_illustration_done: 'Completed Milestones',
  label_milestone_illustration_done_delay: 'Completed but Delayed Milestones',
  label_milestone_illustration_doing_delay: 'Uncompleted and Delayed Milestones',
  label_milestone_illustration_cancel: 'Cancelled Milestones',
  label_milestone_illustration_multi: 'Multiple milestones at the same time',
  label_project_member: 'Project Member',
  label_investment_duration: 'Investment',
  label_plan: 'Plan',
  label_in_actuality: 'In Actuality',
  label_view: 'View',
  label_milestone_endDate_null_hint_pre: 'A total of $total milestones,',
  label_milestone_endDate_null_hint_end: ' have not set planned completed date',
  label_unit: '',
  label_milestone_set_endDate: 'Set Milestone Completed Date',
  label_milestone_name: 'Milestone Name',
  label_next_milestone: 'Next Milestone',
  label_recent_complete_milestone: 'Recently Completed Milestone',
  label_set_endDate: 'Set Date',
  label_none: 'None',
  label_milestone_set_endDate_tip_pre: 'The following are milestones without  planned completed date in ',
  label_milestone_set_endDate_tip_end: '',
  label_filter_and_display: 'Filter',
  label_display: 'Display',
  label_filter_by_project_tag: 'Filter by Project Tag',
  text_display_project_divider: 'Display project divider',
  text_display_delayed_unfinished_milestone: 'Display delayed and uncompleted milestones',
  hint_hide_group_member: 'Hide this member',
  hint_delete_group: 'Delete this group',
  hint_hide_group: 'Hide this group',
  text_confirm_hide_member: 'Hiding this member from the group will not change the member\'s role,are you sure to do this?',
  label_group_by_role: 'Group by role',
  label_group_by_custom: 'Group by custom',
  hint_delete_group_member: 'Delete this member',
  text_confirm_delete_member: 'Confirm to delete this member from custom group？',
  text_title_hide_member: 'Hide Member',
  text_title_delete_member: 'Delete Member',
  text_title_hide_group: 'Hide Group',
  text_title_delete_group: 'Delete Group',
  text_confirm_hide_group: 'Confirm to hide group:($1)?',
  text_confirm_delete_group: 'Confirm to delete group:($1)? Inventments of member in this group will be deleted with the group.',
  hint_add_group_member: 'Add Member',
  hint_add_group: 'Add Group',
  text_group_name: 'Name',
  hint_edit_group: 'Edit this group',
  text_title_edit_group: 'Edit Group',
  label_form_group: 'Group',
  label_form_member: 'Member',
  text_add_member_ps: 'Directions: ',
  text_add_member_ps_prefix: 'If the user you want is not in the project, please go to ',
  text_add_member_ps_here: 'here',
  text_add_member_ps_postfix: ' and set him as a project member',
  tip_input_group_name: 'Please input name',
  tip_input_select_group: 'Please select group',
  tip_input_select_member: 'Please select user',
  label_project_announcement: 'Project Announcement',
  hit_no_optional_group: 'No optional group',
  hit_no_optional_member: 'No optional member',
  label_edit_invest_date: 'Enter Editing Mode',
  hint_edit_invest_date: 'Click to enter edit mode, click on the date cell to edit member investment quickly',
  hint_exit_edit_invest_date: 'After exiting the editing mode, click on the cell can not edit the member investment',
  label_exit_edit_invest_date: 'Exit Editing Mode',
  label_back_to_old_version: 'Back to Old Version',
  hint_exit_full_screen: 'Currently in full screen mode, press esc to exit',
  text_total_members: 'Total ($1)',
  text_hide_project_divider: 'Hide project divider',
  label_history_version: 'Previous Versions',
  label_current_version: 'Current Version',
  label_return: 'Return',
  label_revert_to_version: 'Revert to this version',
  tip_revert_version: 'Reverting to this version will overwrite the current announcement, are you sure to revert?',
  label_use_build_image_or_not: 'Set build image or not',
  label_relate_existing_projects: 'Relate Existing Projects',
  label_more: 'More',
  label_lock: 'Lock',
  label_unlock: 'Unlock',
  label_exit_project: 'Exit Project',
  label_approval_project: 'Approval Project',
  text_lock_req_hint: 'If requirement locked, actions are forbidden including adding,updating,removing,cancelling,archiving and deleting requirements in the project.',
  text_project_locked_hint: 'Requirements are locked,adding,updating,removing,cancelling,archiving and deleting requirements in the project must take the approval process',
  tip_cancel_archive_make_sure: 'Confirm to cancel archive？',
  tip_project_cancel_archive: 'When project is unarchived, sprints, work items and others will not be automatically restored',
  tip_project_unlock_confirm: 'Confirm to unlock project?',
  label_approver: 'Approver',
  label_cc: 'Cc',
  label_project_approval: 'Project Initiation Approval',
  label_project_approval_undo: 'Not yet applied for project approval',
  label_project_approval_doing: 'Project approval is in progress',
  label_project_approval_pass: 'Project approval has passed',
  label_project_approval_fail: 'Failed to approve the project',
  label_tips_start_project_approval: 'select more to start project approval',
  label_tips_restart_project_approval: 'select more to restart project approval',
  label_project_info: 'Project Base Info',
  label_milestone: 'Milestone',
  tip_input_approver: 'Please input approvers',
  label_announcement: 'Announcement',
  label_summary_members: 'Members',
  label_manager: 'Manage',
  label_version: 'Version',
  label_new: 'New',
  label_total_risk_num: 'Total ($1) Risk(s), ',
  label_service: 'Service',
  label_sprint: 'Sprint',
  label_milestone_plan: 'Milestone Plan',
  tip_multi_milestone: 'and other $1 milestones',
  label_insert_term: 'Insert Term',
  label_term: 'Term',
  label_create_term: 'Create Term',
  tip_no_term_list: 'no terms',
  label_aone_data_module: 'Aone Data',
  label_relation: 'relation',
  text_preview: 'preview',
  text_system_error: 'System error',
  label_High: 'High',
  label_Low: 'Low',
  label_total_projects: 'A total of $total projects',
  label_child_project: 'Child Project',
  label_developer: 'Developer',
  label_branch: 'Branch',
  label_Change_content: 'Change Content',
  label_env: 'Project Env',
  label_Change: 'Change',
  text_cr_releasing: 'Releasing',
  text_cr_pending: 'Pending',
  text_cr_pending_integration: 'Pending integration',
  text_cr_in_integration: 'In integration',
  text_application: 'Apply',
  text_cr_developing: 'Developing',
  text_cr_test: 'Testing',
  text_cr_finish: 'Finish',
  text_cr_closed: 'Closed',
  text_cr_second_base: 'Environment updating',
  text_cr_in_audit: 'In Audit',
  text_cr_compiling: 'Compiling',
  label_New_change: 'New change',
  text_New_RPM_change: 'New RPM Change"',
  text_Publish_2nd_party_lib: 'Publish 2nd party lib"',
  text_Load_3rd_party_lib: 'Load 3rd party lib',
  text_Change_module: 'Change module',
  label_total_crs: 'A total of $total changes',
  tip_input_related_project_name: 'Enter name of the related projects to search',
  label_docker_repo_url: 'Set build image url',
  text_tab_swarm: 'Swarm cluster import',
  text_tab_k8s: 'kubernetes cluster import',
  text_tab_account: 'Docker image account management',
  label_shown_project_block: 'Displayed Panels',
  label_hidden_project_block: 'Hidden Panels',
  label_click_to_edit_layout: 'Click to Config Layout Display',
  label_empty_announcement: 'No Announcement',
  label_comma: ', ',
  label_new_and_relate_project: 'Create Project and Relate',
  label_select_project_template: 'Please select a project template:',
  label_agile_product_develop: 'Agile Product Development',
  label_classic_project: 'Project Management',
  label_defect_tracking: 'Defect Tracking',
  tip_agile_product_develop: '<div>- Manage the R&D process using mainstream agile methodology (Scrum/Kanban)</div><div>- Assist continuous improvement with metrics such as Cumulative Flow Diagram</div>',
  tip_classic_project: '<div>- Complete one or more clear goals within a certain time range</div><div>- Track project progress, risks, resources, milestones, etc.</div>',
  tip_defect_tracking: '<div>Normative defect management process, timely and effective tracking, quality assurance</div>',
  tip_select_related_project: 'Please select related projects',
  label_relate_existing: 'Relate Existing',
  label_display_columns: 'Display Columns',
  label_milestone_gantt: 'Gantt Chart',
  label_plan_gantt: 'Planning Gantt chart',
  label_plan_task: 'Planning Task',
  text_plan_task_hint: 'Check tasks to add to Gantt Chart',
  label_title: 'Title',
  label_plan_start: 'Planned Start',
  label_plan_end: 'Planned Complete',
  tip_gantt_owners: 'Project PM, Milestone Owner or Task Assigner',
  text_Display_archived_project: 'Display completed projects',
  label_project_template: 'Project(Program) Template',
  label_open: 'Expand',
  label_close: 'Collapse',
  label_open_all: 'Expand All',
  label_close_all: 'Collapse All',
  text_create_card_holder: 'Input title @assigner, press Enter',
  sub_issue_search_placeholder: 'Input subject or ID, press Enter',
  confirm_cancel_relation: 'Sure to cancel relation ?',
  cancel_relation: 'Cancel relation',
  label_copy_from_other_project: 'Copy from other projects',
  label_select_milestone_copy: 'Please select the milestone',
  label_copy_milestone: 'Copy milestone',
  label_current_project_set: 'Now project (Set)',
  label_current_project: 'Now project',
  label_more_info: 'More info',
  label_project_message: 'Project message',
  text_ecs_region: 'region',
  text_ecs_instanceId: 'instanceId',
  text_ecs_instanceName: 'instanceName',
  text_setting: 'Setting',
  text_default_open: 'Default open',

  label_belonged_project: 'Project',
  text_public_team: 'Public in team',
  text_Accessible_for_team: 'Visible to team staff',


  label_step_1_project_info: '1. Fill in project information',
  label_step_2_project_template: '2. Select project template',
  label_req_workflow: 'Requirement workflow',
  label_task_workflow: 'Task workflow',
  label_bug_workflow: 'Bug workflow',
  label_system_template: 'Standard template',
  label_division_template: 'Team template',

  label_owner_division: 'Team',

  label_colon: ' : ',
  label_product_is_required: 'BU/Product is required',
  tip_create_project: 'Please input project\'s name, the length is not more than 20.',

  label_project_archive: 'Complete project',
  text_delete_project: 'delete project',
  label_more_option: 'more option',
  label_project_setting: 'project setting',
  label_turn_on_share: 'turn on share data to other',
  tip_delete_project: 'delete project and all the project content',
  tip_archive_project: 'Once the project is complete, the project can be marked as a closed project. Re-open is not allowed, please be careful.',
  tip_archive_tip_info: '<div>' +
  '<div>When the project is completed, the project will be closed.' +
  '<span style="color: #fb8c00; font-weight: 600">Warning: The project cann\'t be reopened when closed.</span>' +
  '</div>' +
  '<div>It will cause the following changes:</div>' +
  '<div>-<span style="color: #fb8c00">Project</span>: The completed project is not displayed in ' +
  'the project list or project search result by default; the template cannot be modified after the project is completed; the progress is automatically set to 100%.</div>' +
  '<div>-<span style="color: #fb8c00">Chart</span>: Workitems for completed projects will still be counted during chart statistics</div>' +
  '<div>-<span style="color: #fb8c00">Sprint</span>：Sprint Creation is not allowed in completed projects</div>' +
  '<div>-<span style="color: #fb8c00">Workitem</span>：Workitem Creation is not allowed in completed projects</div>' +
  '</div>',
  label_is_admin: 'is admin',
  label_input_username: 'type username to search',
  label_create_child_project: 'Create child project',
  label_relate_child_project: 'Related child project',
  label_create_child_project_set: 'Create child project set',
  label_relate_child_project_set: 'Related child project set',
  text_relate_child_project: 'Associate the following items into sub projects',
  layout_setting: 'Layout settings',
  label_app_template: 'App Template',
  label_build_config: 'Build Config',
  label_app_create_review: 'App Info Review',
  label_sure_to_create_app: 'Create',
  label_go_to_application: 'View App',
  label_repo_source: 'Code Source',
  label_repo: 'Repo',
  label_gitee: 'Gitee',
  label_template_name: 'Template name',
  label_select_app_template: 'Select Application Template',
  label_language: 'Language',
  label_other_language: 'other languages',
  label_deploy_options: 'Deploy Options',
  label_aol: 'ECS',
  label_aliyuncontainer: 'Aliyun Container Service',
  label_kubernetes: 'Kubernetes',
  label_edas: 'EDAS',
  label_sofa: 'SOFA',
  label_non_product: 'Non Product',
  text_edit_roles: 'edit roles',
  text_del_role: 'Del role',
  text_del_role_confirm: 'Are you sure to del this role?',
  text_switch_open: 'ON',
  text_switch_closed: 'OFF',
  text_function_closed: 'Function not open',
  text_user_name: 'username',
  text_project_option: 'project option',
  text_project_explanation: 'Project is the active in a period  of time to achieve one\'s goals with expected start date, end date, and the flow of establish, approval, finish',
  text_nameSpace_explanation: 'Name space is long standing for cooperation between the feature team, ',
  tips_child_must_project_when_parent_is_project: 'The current template must be \'project\' when parent project\'s template is \'project\'',
  tips_parent_must_business_when_child_is_business: 'The parent\'s template cann\'t be \'project\' when current project\'s template is \'business\'',
  tips_change_to_project_fail_error: 'The template cann\'t be \'project\' when has chilren which template is \'business\'. Please set these project\'s template to be \'project\':',
  text_child_has_business: 'Has Business In Children',
  text_set_project_expected_date: 'Set Expected Date',
  label_closed_project: 'Closed',
  text_lifecycle_abandoned: 'This field will be discarded. If the project is finished or discarded, go to Settings > More > Close / Delete.',
  text_edit_progress: 'Edit Progress',
  text_resignation_batch_transfer: 'Batch transfer',
  text_resignation_transfer_tip: ' participating projects',
  text_resignation_transfer_tip_title: 'View transfer rules',
  text_resignation_transfer_tip_desc_0: 'After transferring project to others, following actions will be performed',
  text_resignation_transfer_tip_desc_1: '1.Replace my role of the project to others',
  text_resignation_transfer_tip_desc_2: '2.Change unfinished work-items which assigned to me in this project to others',
  text_resignation_transfer_tip_desc_3: '3.Change unfinished work-items which tracked by me in this project to others',
  text_resignation_transfer: 'Transfer',
  text_resignation_project_name: 'Project name',
  text_resignation_role: 'Role',
  text_resignation_undone_number: 'Number of undone workItems',
  text_resignation_department: 'Department',
  text_resignation_operation: 'Operation',
  text_resignation_transfer_project: 'Transfer project',
  text_resignation_transfer_to: 'Transfered to',
  text_resignation_choose_user: 'Please choose user',
  text_resignation_transfer_success: 'Transfer succeed',
  text_resignation_transfer_failed: 'Transfer failed',
  text_resignation_projects_selected_empty: 'Please choose transfered projects',
  label_submit_approval: 'Submit Approval',
  label_submit: '提交',
  text_plan_start_time_can_not_be_null: 'Planed start date can not be null',
  text_plan_end_time_can_not_be_null: 'Planed end date can not be null',
  text_cancel_approval_hint: 'Cancelling the approval process will terminate the project creation process',
  text_approval_list_hint: 'Please go to the top navigation "To Do" to view the progress after submitting',
  text_error_get_bu: 'get bu info error',
  text_business_recent90PV_zero_option: 'This project has no pv in recent 90 days, please delete it if is abandon',
  text_project_recent90PV_zero_option: 'This project has no pv in recent 90 days, please close it if is finished ; or delete if if is abandon',
  text_project_recent90PV_not_zero_option_1: 'The expect end date of this project is $1. Please close it if finished; If is delayed, please',
  text_project_recent90PV_not_zero_option_2: 'Change Expect End Date',
  text_project_recent90PV_not_zero_option_3: 'Change Project Template',
  text_project_recent90PV_not_zero_option_4: 'If is long run, please',
  text_remove_staff_code_access_of_this_region: 'remove all code access of this user in the company',
  text_remove_code_access_failed: 'the following repos or groups are not removed ,please deal by yourself ',
  text_system_remind: 'system remind',
  text_remove_member_remind: 'if you delete the user, he/she will not be able to enter this company and his/her applications will be transferred to admin',
  text_project_group_in_code: 'group',
  label_project_template_setting: 'Project Template',
  label_project_template_root_setting: 'Division Template',
  label_project_services_setting: 'Project Services',
  label_system_default: 'System',
  label_inherit: 'Inherit',
  text_cf_detail: 'Details',
  text_cf_name: 'Name',
  label_field_format: 'Format',
  label_cf_description: 'Description',
  label_cf_required: 'Required',
  label_cf_possible_value: 'Possible Values',
  text_create_group_success: 'group create success',
  text_delete_group_success: 'group delete success',
  text_update_group_success: 'group update success',
  label_deleted_project: '已删除',
  text_project_group: 'Project Group',
  label_git_third: 'Git Group/Repo',
  text_product_line_edit_hint: 'Edit more info on productLine edit page',
};

export default en;



/** WEBPACK FOOTER **
 ** ./src/utils/locale/en_US.js
 **/